<template>
  <v-card min-height="100vh">
    <BaseToolbar
      ref="base-toolbar"
      :title="$t('recurring_debit.titles.generate_files')"
      @close="$emit('close')"
      type-title="icon"
      icon="cloud_done"
      backgroundColor="#2661FF"
    />
    <v-card-text
      style="overflow-y: auto;height: calc(100vh - 64px); background-color:  #f2f4f4;"
    >
      <v-container class="px-4">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12">
              <v-card class="custom_card rounded-lg">
                <v-card class="ma-5 custom_card rounded-lg" flat>
                  <v-card-title class="justify-center">
                    {{ $t("recurring_debit.generate.file_manager") }}
                  </v-card-title>
                </v-card>
                <v-card
                  id="filters"
                  class="pa-5 ma-5 custom_card rounded-lg"
                  flat
                >
                  <v-card-title>
                    <v-icon color="#344054">
                      tune
                    </v-icon>
                    <span class="title title_color px-4">
                      {{ $t("recurring_debit.generate.filter_title") }}
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-row
                      no-gutters
                      class="d-flex justify-center align-center"
                    >
                      <!--------------------------------------------------------->
                      <!-- DATE PICKERS ------------------------------------->
                      <!--------------------------------------------------------->
                      <v-col cols="12" md="2" sm="6" class="ma-2">
                        <v-menu
                          ref="menu"
                          v-model="filters.dates.startDateMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="filters.dates.startDate"
                              v-bind="attrs"
                              v-on="on"
                              :label="$t('dates.from')"
                              outlined
                              class="rounded-lg"
                              dense
                              hide-details
                              prepend-inner-icon="calendar_month"
                              readonly
                              required
                            >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="filters.dates.startDate"
                            no-title
                            scrollable
                            color="#2661FF"
                            :max="validateMaxDate()"
                            @input="filters.dates.startDateMenu = false"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="2" sm="6" class="ma-2">
                        <v-menu
                          ref="menu"
                          v-model="filters.dates.endDateMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="filters.dates.endDate"
                              :label="$t('dates.until')"
                              outlined
                              class="rounded-lg"
                              dense
                              hide-details
                              prepend-inner-icon="calendar_month"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              required
                            >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="filters.dates.endDate"
                            no-title
                            scrollable
                            color="#2661FF"
                            :min="validateMinDate()"
                            :max="$moment().format('YYYY-MM-DD')"
                            @input="filters.dates.endDateMenu = false"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <!--------------------------------------------------------->
                      <!-- BANKS ------------------------------------->
                      <!--------------------------------------------------------->
                      <v-col cols="12" md="2" sm="6" class="ma-2">
                        <v-select
                          ref="field-bank"
                          v-model="filters.bank_id"
                          :items="banks"
                          item-text="name"
                          item-value="id"
                          :label="$t('recurring_debit.generate.table.bank')"
                          clearable
                          outlined
                          class="rounded-lg"
                          dense
                          hide-details
                          @click:clear="filters.bank = null"
                        >
                          <template v-slot:item="{ item }">
                            {{ capitalize(item.name) }}
                          </template>
                        </v-select>
                      </v-col>
                      <!--------------------------------------------------------->
                      <!-- STATUSES ------------------------------------->
                      <!--------------------------------------------------------->
                      <v-col cols="12" md="2" sm="6" class="ma-2">
                        <v-select
                          ref="field-status"
                          v-model="filters.subscription_status_id"
                          :items="statuses"
                          item-text="attributes.description"
                          item-value="id"
                          :label="
                            $t(
                              'recurring_debit.generate.subscription_status_select_title'
                            )
                          "
                          clearable
                          outlined
                          class="rounded-lg"
                          dense
                          hide-details
                          @click:clear="filters.status = null"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-card
                  id="file-options"
                  class="pa-5 ma-5 custom_card rounded-lg"
                  flat
                >
                  <v-card-title>
                    <v-icon color="#344054">
                      folder
                    </v-icon>
                    <span class="title title_color px-4">
                      {{ $t("recurring_debit.generate.options_files") }}
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-row
                      no-gutters
                      class="d-flex justify-center align-center"
                    >
                      <!--------------------------------------------------------->
                      <!-- APPLICATION DATE ------------------------------------->
                      <!--------------------------------------------------------->
                      <v-col cols="12" md="2" sm="6" class="ma-2">
                        <v-menu
                          ref="menu"
                          v-model="fileOptions.applicationDateMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="fileOptions.application_date"
                              v-bind="attrs"
                              v-on="on"
                              :label="
                                $t('recurring_debit.generate.application_date')
                              "
                              outlined
                              class="rounded-lg"
                              dense
                              prepend-inner-icon="calendar_month"
                              readonly
                              required
                            >
                              <template v-slot:append>
                                <v-tooltip max-width="350" bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      color="grey"
                                      class="text--darken-1"
                                      dark
                                      v-on="on"
                                    >
                                      info_outline
                                    </v-icon>
                                  </template>
                                  <span>
                                    {{
                                      $t(
                                        "recurring_debit.generate.application_date_tooltip"
                                      )
                                    }}
                                  </span>
                                </v-tooltip>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="fileOptions.application_date"
                            no-title
                            scrollable
                            color="#2661FF"
                            :min="$moment().format('YYYY-MM-DD')"
                            @input="fileOptions.applicationDateMenu = false"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <!--------------------------------------------------------->
                      <!-- FILE NAME ------------------------------------->
                      <!--------------------------------------------------------->
                      <v-col cols="12" md="2" sm="6" class="ma-2">
                        <v-text-field
                          v-model="fileOptions.name"
                          :label="$t('recurring_debit.generate.name')"
                          outlined
                          class="rounded-lg"
                          dense
                          required
                          :maxlength="100"
                          :rules="rules.name"
                        ></v-text-field>
                      </v-col>
                      <!--------------------------------------------------------->
                      <!-- SEQUENCES ------------------------------------->
                      <!--------------------------------------------------------->
                      <v-col cols="12" md="2" sm="6" class="ma-2">
                        <v-select
                          ref="field-sequence"
                          v-model="fileOptions.sequence"
                          :items="sequences"
                          :label="$t('recurring_debit.generate.sequence')"
                          clearable
                          outlined
                          class="rounded-lg"
                          dense
                          required
                          :rules="rules.sequence"
                          @click:clear="fileOptions.sequence = null"
                        >
                          <template v-slot:append>
                            <v-tooltip max-width="350" bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  color="grey"
                                  class="text--darken-1"
                                  dark
                                  v-on="on"
                                >
                                  info_outline
                                </v-icon>
                              </template>
                              <span>
                                {{
                                  $t("recurring_debit.generate.sequence_info")
                                }}
                              </span>
                            </v-tooltip>
                          </template>
                        </v-select>
                      </v-col>
                      <!--------------------------------------------------------->
                      <!-- EXPORT FORMAT ------------------------------------->
                      <!--------------------------------------------------------->
                      <v-col cols="12" md="2" sm="6" class="ma-2">
                        <v-select
                          v-model="fileOptions.file_format_id"
                          :items="fileFormats"
                          item-text="name"
                          item-value="id"
                          :label="$t('recurring_debit.generate.file_format')"
                          outlined
                          class="rounded-lg"
                          dense
                          required
                          :rules="rules.format"
                        >
                          <template v-slot:item="{ item }">
                            {{ capitalize(item.name) }}
                          </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-card-actions>
                  <v-row no-gutters class="ma-4">
                    <v-col
                      cols="12"
                      class="d-flex justify-end align-center"
                      style="gap: 12px"
                    >
                      <v-btn
                        @click="clearFilters"
                        color="#2661FF"
                        class="rounded-lg"
                        outlined
                      >
                        <span>
                          {{ $t("recurring_debit.main.clear_filter") }}
                        </span>
                      </v-btn>
                      <v-btn
                        @click="generateFile"
                        :loading="isLoading"
                        :disabeld="!valid"
                        color="primary"
                        class="rounded-lg"
                      >
                        <span>
                          {{ $t("recurring_debit.main.calculate") }}
                        </span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import BaseToolbar from "@/components/BaseToolbar";
import LoadingDialog from "@/components/Common/LoadingDialog";

export default {
  name: "GenerateFile",
  components: { BaseToolbar, LoadingDialog },
  data() {
    return {
      isLoading: false,
      valid: true,
      filters: {
        dates: {
          startDateMenu: false,
          endDateMenu: false,
          startDate: null,
          endDate: null
        },
        bank_id: null,
        subscription_status_id: null
      },
      fileOptions: {
        applicationDateMenu: false,
        application_date: this.$moment()
          .startOf("day")
          .format("YYYY-MM-DD"),
        name: null,
        sequence: null,
        file_format_id: null
      },
      rules: {
        name: [
          v => !!v || this.$t("general.required"),
          v => (v && v.length <= 100) || this.$t("general.limit_exceeded")
        ],
        sequence: [v => !!v || this.$t("general.required")],
        format: [v => !!v || this.$t("general.required")]
      }
    };
  },
  computed: {
    ...mapState({
      banks: ({ recurringDebit: { banks } }) => banks,
      statuses: ({ recurringDebit: { subscription_statuses } }) =>
        subscription_statuses,
      fileFormats: ({ recurringDebit: { fileFormats } }) => fileFormats
    }),
    sequences() {
      return Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));
    }
  },
  methods: {
    ...mapActions({
      generateFileAction: "recurringDebit/generateFile"
    }),
    getMinDate(date1, date2) {
      return new Date(Math.min(new Date(date1), new Date(date2)))
        .toISOString()
        .split("T")[0];
    },
    validateMinDate() {
      const startDate = this.filters.dates.startDate;
      return startDate ? startDate : null;
    },
    validateMaxDate() {
      const { filters } = this;
      const currentDate = this.$moment().format("YYYY-MM-DD");

      return filters.dates.endDate
        ? this.getMinDate(currentDate, filters.dates.endDate)
        : currentDate;
    },
    async validate() {
      try {
        const valid = await this.$refs.form.validate();

        if (!valid) {
          throw new Error("Invalid");
        }
      } catch (error) {
        throw error;
      }
    },
    async generateFile() {
      try {
        const { fileOptions, filters } = this;
        this.isLoading = true;

        await this.validate();

        const payload = {
          plain_file: {
            name: fileOptions.name,
            file_format_id: fileOptions.file_format_id,
            sequence: fileOptions.sequence,
            application_date: this.$moment(fileOptions.application_date).unix()
          },
          subscription: {
            subscription_status_id: filters.subscription_status_id,
            starting_at: this.$moment(filters.dates.startDate).unix(),
            ending_at: this.$moment(filters.dates.endDate).unix()
          }
        };

        await this.generateFileAction(payload);

        this.$emit("close");
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    clearFilters() {
      const intialFilters = {
        dates: {
          startDateMenu: false,
          endDateMenu: false,
          startDate: this.$moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: this.$moment()
            .endOf("day")
            .format("YYYY-MM-DD")
        },
        bank_id: null,
        subscription_status_id: null
      };
      const initialFileOptions = {
        sequence: null,
        name: null,
        format_id: null,
        application_date: this.$moment()
          .startOf("day")
          .format("YYYY-MM-DD")
      };

      this.filters = intialFilters;
      this.fileOptions = initialFileOptions;
    },
    capitalize(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
};
</script>

<style>
.custom_card {
  border: 1px solid #d0d3db !important;
}

.title_color {
  color: #344054 !important;
}
</style>
